import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 100%;
  padding: 1.3125rem 1rem;
  border-radius: 0.75rem;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  background-color: ${primitive.bk.$flamingOrange10};

  ${Styles.desktop} {
    height: 172px;
    align-items: center;
    border-radius: 12px;
    overflow: hidden;
    padding: 32px 16px;
  }
`;

export const SignupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  ${Styles.desktop} {
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding: 0 8px;
    border-radius: 12px;
    gap: 0.75rem;
  }
`;

export const MobileCrownSvgContainer = styled.div`
  width: 116px;
  height: 246.5px;
  overflow: visible;
  position: absolute;
  inset-block-start: -21px;
  inset-inline-end: -8px;
  ${Styles.desktop} {
    display: none;
  }
`;

export const CrownSvgContainer = styled.div`
  display: none;
  ${Styles.desktop} {
    position: absolute;
    inset-block-start: 0;
    inset-inline-start: 0;
    width: 100%;
    height: 100%;
    display: flex;
  }
  ${Styles.desktopLarge} {
    scale: 1.4;
  }
`;

export const SignupTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  border-radius: 8px;
  padding: 0.5rem;
  padding-inline-end: 0.6875rem;

  ${Styles.desktop} {
    width: 100%;
    gap: 8px;
    margin-inline-start: 8px;
    padding: 0;
  }
`;

export const SignupButtonContainer = styled.div`
  border-radius: 3rem;
  background: ${primitive.bk.$fieryRed};
  width: max-content;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  ${Styles.desktop} {
    padding: 0 5.675rem;
  }
`;

export const SignupButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;

  ${Styles.desktop} {
    padding-inline: 0.5rem;
  }
`;

export const ButtonLabel = styled.span`
  font-family: ${Styles.fontFamily.brand};
  font-weight: 700;
  font-size: 0.75rem;
  line-height: 1.125rem;
  letter-spacing: 0;
  color: ${primitive.$white};

  ${Styles.desktop} {
    font-size: 1rem;
    line-height: 1.5rem;
  }
`;

export const TextPartContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: calc(100% - 90px);

  ${Styles.desktop} {
    width: 100%;
    align-items: center;
    gap: 0.5rem;
    padding-block: 0.5rem;
  }
`;

export const TitleText = styled.div`
  font-family: ${Styles.fontFamily.brand};
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 16px;
  color: ${primitive.bk.$bbqBrown};

  ${Styles.desktop} {
    font-size: 1.125rem;
    line-height: 1.25rem;
  }
`;

export const DescriptionText = styled.div`
  font-family: ${Styles.fontFamily.body};
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 16px;
  color: ${primitive.bk.$bbqBrown};

  ${Styles.desktop} {
    font-size: 0.875rem;
    line-height: 1rem;
  }
`;
